<template>
    <div class="session__show_people_table">
        <component-table
            :labels="[
                {
                    key: ['firstName', 'lastName'],
                    title: 'Name',
                    type: 'string',
                    sortable: true
                },
                {
                    key: 'email',
                    title: 'Email',
                    type: 'string',
                    sortable: true
                },
                {
                    key: 'bookingStatus',
                    title: 'Status',
                    type: 'string',
                    sortable: true
                },
                {
                    key: 'actions',
                    title: '',
                    type: '',
                    sortable: false
                }
            ]"
            :items="items"
            :component-table-item="SessionShowPeopleTableItem"
            @emit-view-booking-form="emitViewBookingForm"
            @emit-remove-from-waitlist="emitRemoveFromWaitlist"
            @emit-invite-person="emitInvitePerson"
            @emit-book-person="emitBookPerson"
            @emit-cancel-invite="emitCancelInvite"
            @emit-resend-invite="emitResendInvite"
            @emit-decline-booking="emitDeclineBooking"
            @emit-approve-booking="emitApproveBooking"
            @emit-cancel-booking="emitCancelBooking"
            @emit-view-cancellation="emitViewCancellation"
        />
    </div>
</template>

<script>
import SessionShowPeopleTableItem from '@/components/ebs/sessions/show/SessionShowPeopleTableItem'
import ComponentTable from '@/components/default/shared/ComponentTable'

export default {
  components: {
    ComponentTable
  },
  name: 'session-show-people-table',
  data () {
    return {
      SessionShowPeopleTableItem
    }
  },
  props: {
    items: {
      type: [Array, Object]
    }
  },
  methods: {
    emitViewBookingForm: function (id) {
      this.$emit('emit-view-booking-form', id)
    },
    emitRemoveFromWaitlist: function (id) {
      this.$emit('emit-remove-from-waitlist', id)
    },
    emitInvitePerson: function (id) {
      this.$emit('emit-invite-person', id)
    },
    emitBookPerson: function (id) {
      this.$emit('emit-book-person', id)
    },
    emitCancelInvite: function (id) {
      this.$emit('emit-cancel-invite', id)
    },
    emitResendInvite: function (id) {
      this.$emit('emit-resend-invite', id)
    },
    emitDeclineBooking: function (id) {
      this.$emit('emit-decline-booking', id)
    },
    emitApproveBooking: function (id) {
      this.$emit('emit-approve-booking', id)
    },
    emitCancelBooking: function (id) {
      this.$emit('emit-cancel-booking', id)
    },
    emitViewCancellation: function (id) {
      this.$emit('emit-view-cancellation', id)
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/sessions/sessionshowpeopletable";
</style>
